import { render, staticRenderFns } from "./OrderInvoiceDetails.vue?vue&type=template&id=3b338c01"
import script from "./OrderInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports